import React from 'react';
import { LT } from '../lib/appCatalogue';

/* The language strip shared by the newsletter and events editors. FR is
 * the canonical copy (top-level fields); NL and EN live in a
 * `translations` JSON with the same keys. */
export const LANGS = ['fr', 'nl', 'en'];
export const LANG_LABEL = { fr: 'Français', nl: 'Nederlands', en: 'English' };

/* A translations object pre-seeded with every locale slot so controlled
 * inputs never bind to `undefined`. Existing values pass through, keys we
 * don't know about (e.g. `items` on bullet sections) are preserved. */
export function normalizeTranslations(raw, fields) {
  const out = {};
  for (const lang of LANGS) {
    const src = (raw && raw[lang]) || {};
    out[lang] = { ...src };
    for (const f of fields) {
      if (out[lang][f] == null) out[lang][f] = '';
    }
  }
  return out;
}

/* "Has any localized field been filled in for this locale?" · decorates
 * the strip with a dot per language. */
export function tabStatusFor(translations, fields) {
  const out = {};
  for (const lang of LANGS) {
    const src = (translations && translations[lang]) || {};
    out[lang] = fields.some(f => (src[f] || '').trim() !== '');
  }
  return out;
}

/* Read / write one localized field of a draft: FR edits the top-level
 * field, the other languages edit their translations slot. */
export function localizedField(draft, lang, field) {
  if (lang === 'fr') return draft?.[field] || '';
  return ((draft?.translations || {})[lang] || {})[field] || '';
}
export function setLocalizedField(draft, lang, field, value) {
  if (lang === 'fr') return { ...draft, [field]: value };
  const next = { ...(draft.translations || {}) };
  next[lang] = { ...(next[lang] || {}), [field]: value };
  return { ...draft, translations: next };
}

export const LangTabs = ({ value, onChange, status, sticky = false }) => (
  <div className={`inline-flex items-center rounded-xl text-[12.5px] ${sticky ? 'sticky top-2 z-10' : ''}`}
       style={{ background: LT.beigeLight, border: `1px solid ${LT.green30}` }}>
    {LANGS.map((lang, i) => {
      const filled = status?.[lang];
      const active = value === lang;
      return (
        <button
          key={lang}
          type="button"
          onClick={() => onChange(lang)}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 transition ${i > 0 ? 'border-l' : ''}`}
          style={{
            background: active ? LT.greenDeep : 'transparent',
            color: active ? '#fefefe' : LT.greenDeep,
            borderColor: LT.green30,
            fontWeight: active ? 600 : 400,
          }}>
          <span>{LANG_LABEL[lang]}</span>
          {!active && (
            <span aria-hidden className="inline-block h-1.5 w-1.5 rounded-full"
                  style={{ background: filled ? '#3d6b54' : LT.green30 }} />
          )}
        </button>
      );
    })}
  </div>
);
